import styled from "styled-components";
import { Link } from "react-router-dom";
import { Container } from "../../globalStyles";

// * General styles ...

export const Nav = styled.nav`
  background: #202023;
  color: #e8e9eb;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 999;
`;

export const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  height: 80px;
  ${Container}
`;

export const NavLogo = styled(Link)`
  color: #e8e9eb;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  transition: all 0.3s ease-out;
  padding: 1rem;

  &:hover {
    color: #fff;
    transition: all 0.3s ease-out;
  }

  @media screen and (max-width: 960px) {
    font-size: 1.2rem;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;

  @media screen and (max-width: 960px) {
    background: #202023;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 40px;
    right: ${({ click }) => (click ? 0 : "-100%")};
    transition: all 0.4s ease;
  }
`;

export const NavItem = styled.li`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const NavLinks = styled(Link)`
  color: #e8e8e8;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  text-decoration: none;
  padding: 0.5rem 0.5rem;
  height: 100%;
  transition: all 0.3s ease;

  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
  }
  &:hover {
    color: #fff;
    transition: all 0.3s ease;
  }
`;

export const VerticalLine = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: flex;
    background-color: #494949;
    width: 100%;
    height: 1px;
  }
`;

export const SmallVerticalLine = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: flex;
    background-color: #494949;
    width: 70%;
    height: 1px;
  }
`;

// * Desktop Specefic

export const UserLogo = styled(Link)`
  color: #e8e9eb;
  justify-self: center;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  transition: all 0.3s ease-out;
  padding: 1rem;
  &:hover {
    color: #fff;
    transition: all 0.3s ease-out;
  }
  @media screen and (max-width: 960px) {
    display: none;
  }
`;

//  * Mobile Specific ...

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    color: #e8e9eb;
    justify-self: flex-start;
    cursor: pointer;
    text-decoration: none;
    font-size: 1.2rem;

    display: flex;
    align-items: center;
    transition: all 0.3s ease-out;
    padding: 1rem;
    &:hover {
      color: #fff;
      transition: all 0.3s ease;
    }
  }
`;

export const MobileNavItem = styled.li`
  display: none;
  @media screen and (max-width: 960px) {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2rem;

    &:first-child {
      margin-top: 50px;
    }
  }
`;

export const MobileNavLogo = styled(Link)`
  display: none;
  @media screen and (max-width: 960px) {
    color: #e8e8e8;
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    text-decoration: none;
    height: 100%;
    transition: all 0.3s ease;
    text-align: center;
    display: table;
    margin-top: 6px;
    padding: 0.5rem;
  }
  &:hover {
    color: #fff;
    transition: all 0.3s ease-out;
  }
`;

export const MobileNavLinks = styled(Link)`
  display: none;

  @media screen and (max-width: 960px) {
    color: #e8e8e8;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    text-decoration: none;
    height: 100%;
    transition: all 0.3s ease;
    text-align: center;
  }
  &:hover {
    color: #fff;
    transition: all 0.3s ease;
  }
`;
